var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.visible)?_c('div',{staticClass:"sticky-info-box cp-btn",class:_vm.styleClasses},[_c('div',{staticClass:"sticky-info-inner"},[_vm._t("StickyInfoText")],2),_c('button',{staticClass:"close",on:{"click":_vm.close}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }